import Splide from "@splidejs/splide";
import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

/* Header scroll transition on homepage */

document.addEventListener('DOMContentLoaded', () => {
	const header = document.getElementById('header');
	const mainHeader = document.getElementById('main-header');
	const triggerElement = document.getElementById('header-transition-trigger'); // Replace with your trigger element
	const burgerMenu = document.getElementById("burger-menu");

	function updateHeaderState() {
		const isScrolled = window.scrollY > (triggerElement.offsetTop - header.offsetHeight);
		const isMobileOpen = mainHeader.dataset.mobileToggle === 'true';

		// Show solid background if either mobile menu is open OR scrolled
		mainHeader.dataset.solid = (isMobileOpen || isScrolled) ? 'true' : 'false';
	}

	if (document.body.classList.contains('template-home')) {
		window.addEventListener('scroll', updateHeaderState);

		// Initial state
		updateHeaderState();
	}

	/* Mobile Menu */
	if (burgerMenu) {
		burgerMenu.addEventListener("click", () => {
			const currentState = mainHeader.dataset.mobileToggle === "true";
			mainHeader.dataset.mobileToggle = (!currentState).toString();

			if (document.body.classList.contains('template-home')) {
				// Update header state
				updateHeaderState();
			}
		});
	}
	/* End Mobile Menu */
});

/* Slider */
document.addEventListener("DOMContentLoaded", function () {
  const testimonialElement = document.querySelector("[data-testimonial-splide]");
  if (testimonialElement) {
    const testimonialSplide = new Splide('[data-testimonial-splide]', {
      type: 'loop',
      perPage: 1,
      pagination: true,
      arrows: true,
      autoplay: true,
      interval: 5000
    });
    testimonialSplide.mount();
  }
});

const heroElement = document.querySelector(".hero-splide");
if (heroElement) {
  const heroSplide = new Splide(".hero-splide", { type: "fade", arrows: false, pagination: false });

  const prevButton = document.querySelector(".hero-prev");
  const nextButton = document.querySelector(".hero-next");

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      heroSplide.go("<");
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      heroSplide.go(">");
    });
  }

  // Set initial credit text
  heroSplide.on("mounted", function () {
    const activeSlide = heroSplide.Components.Elements.slides[heroSplide.index];
    const credit = activeSlide.dataset.credit;
    const creditElement = document.getElementById("slide-credit");
    if (creditElement) {
      creditElement.textContent = credit;
    }
  });

  // Update credit text on slide change
  heroSplide.on("moved", function () {
    const activeSlide = heroSplide.Components.Elements.slides[heroSplide.index];
    const credit = activeSlide.dataset.credit;
    const creditElement = document.getElementById("slide-credit");
    if (creditElement) {
      creditElement.textContent = credit;
    }
  });

  heroSplide.mount();
}

document.addEventListener("DOMContentLoaded", function () {
	const serviceElement = document.querySelector("[data-service-splide]");
	if (serviceElement) {
		const serviceSplide = new Splide('[data-service-splide]', {
			type: 'loop',
			perPage: 1,
			pagination: false,
			arrows: false,
			autoplay: true,
			interval: 5000
		});

		const prevButton = document.querySelector(".splide-prev");
		const nextButton = document.querySelector(".splide-next");

		if (prevButton) {
			prevButton.addEventListener("click", () => {
				serviceSplide.go("<");
			});
		}

		if (nextButton) {
			nextButton.addEventListener("click", () => {
				serviceSplide.go(">");
			});
		}

		serviceSplide.mount();
	}
});
/* End Slider */
